import { Box } from '@mui/material'
import { FooterProps } from './Footer.types'

export const Footer = ({
  copyrightText,
  privacyText,
  handlePrivacyClick,
  cookiesText,
  handleCookiesClick,
}: FooterProps) => {
  return (
    <Box
      component="footer"
      display="flex"
      justifyContent="center"
      alignItems="center"
      fontSize={14}
      color="primary.main"
      bgcolor="common.white"
      height="60px"
    >
      <Box display="flex">
        <Box mr={1}>&copy; 2009 - {new Date().getFullYear()}.</Box>
        <Box mr={1}>{copyrightText}.</Box>
        <Box>SupplyVue Ltd.</Box>
        <Box
          ml={2}
          role="link"
          onClick={handlePrivacyClick}
          sx={{
            cursor: 'pointer',
          }}
        >
          {privacyText}
        </Box>
        <Box mx={2}>|</Box>
        <Box
          role="link"
          onClick={handleCookiesClick}
          sx={{
            cursor: 'pointer',
          }}
        >
          {cookiesText}
        </Box>
      </Box>
    </Box>
  )
}
